import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-agregar-empresa',
  templateUrl: './agregar-empresa.component.html',
  styleUrls: ['./agregar-empresa.component.css']
})
export class AgregarEmpresaComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  imagePreview: string | ArrayBuffer;
  classFlag: boolean = false;

  constructor(
    public dialogAgregarEmpresaRef: MatDialogRef<AgregarEmpresaComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
  ) { }

  ngOnInit() {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
  }

  registerCompanyForm = new FormGroup({
    nombreEmpresa: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]),
    numRif: new FormControl('', [Validators.required, Validators.pattern(Constanst.REGEXP_RIF), Validators.minLength(1), Validators.maxLength(100)]),
    numNit: new FormControl('', [Validators.minLength(1), Validators.maxLength(100)]),
    direccionEmpresa: new FormControl('', [Validators.minLength(10), Validators.maxLength(250)]),
    numTelefonoEmpresa: new FormControl('', [Validators.minLength(10)]),
    correoEmpresa: new FormControl('', [Validators.pattern(Constanst.REGEXP_EMAIL)]),
    nombreRepresentante: new FormControl('', [Validators.minLength(4), Validators.maxLength(20)]),
    logoEmpresa: new FormControl(null)
  });

  onSubmit(): void {
    if (this.registerCompanyForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_ADD_COMPANY, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {

        this.route = '/registerCompanyBudget';
        this.method = 'POST';

        let data = {
          companyBudgetEntity: {
            rif: this.registerCompanyForm.controls['numRif'].value,
            companyName: this.registerCompanyForm.controls['nombreEmpresa'].value,
            email: this.registerCompanyForm.controls['correoEmpresa'].value,
            fiscalAddress: this.registerCompanyForm.controls['direccionEmpresa'].value,
            phone: this.registerCompanyForm.controls['numTelefonoEmpresa'].value,
            legalAgent: this.registerCompanyForm.controls['nombreRepresentante'].value,
            nit: this.registerCompanyForm.controls['numNit'].value
          }
        }

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$))
          .subscribe(response => {
            this.apiCallService.hideSpinner();
            if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
              this.helperClassService.notifierNewChangeBudget.emit(data.companyBudgetEntity.companyName!);
              const dialogUpdate = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_COMPANY_ADDED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
              dialogUpdate.afterClosed().subscribe((result: string) => {
                this.closeDialogAgregarEmpresa();
              });

            } else {
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_ADD_COMPANY_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
            }
          },
            error => {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            });

      } else {
        dialog.close(false);
      }
    });
  };

  closeDialogAgregarEmpresa() {
    this.dialogAgregarEmpresaRef.close();
  }

}
